require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-pages-general-contractor.json") })
        }
      }, "path---en-pages-general-contractor");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-pages-general-contractor!./.cache/json/en-pages-general-contractor.json
// module id = 758
// module chunks = 231608221292675